module.exports = __webpack_public_path__ + "img/de10f6fc32bb5130cd639446dcfd7e50.png";